import { SCAN_STATE } from '../interfaces/ScanState';

export class ScanCrawlStateHelper {
	static isInProgress(state: string): boolean {
		return state === SCAN_STATE.NEW || state === SCAN_STATE.RUNNING;
	}

	static isDone(state: string): boolean {
		return state === SCAN_STATE.DONE;
	}

	static isIngesting(state: string): boolean {
		return state === SCAN_STATE.INGESTING;
	}

	static isCanceling(state: string): boolean {
		return state === SCAN_STATE.CANCELING;
	}

	static isFailed(state: string): boolean {
		return state === SCAN_STATE.FAILED;
	}

	static isCanceled(state: string): boolean {
		return state === SCAN_STATE.CANCELED;
	}

	static isPagesCsvReady(state: SCAN_STATE): boolean {
		return state === SCAN_STATE.DONE || state === SCAN_STATE.DONE_WITHOUT_CSV;
	}

	static isIssuesCsvReady(state: SCAN_STATE): boolean {
		return state === SCAN_STATE.DONE || state === SCAN_STATE.DONE_WITHOUT_PAGES_CSV;
	}

	static isAnyCsvReadyForDownload(state: SCAN_STATE): boolean {
		return this.isIssuesCsvReady(state) || this.isPagesCsvReady(state);
	}

	static isScanResultsReady(state: SCAN_STATE): boolean {
		return this.isDone(state) || this.isIssuesCsvReady(state) || this.isPagesCsvReady(state);
	}
}
